import { useState } from "react";
import { Settings2, Save, X } from "lucide-react";
import { api } from "@/api";
import { toast } from "@/lib/toast";
import { FREQ_LABEL, MONTHS, inputCls } from "./_shared";

export function TaxSettingsCard({ settings, onSaved }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(settings);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const r = await api.put("/admin/cabinet-taxes/settings", { filing_frequency: form.filing_frequency, fiscal_year_end_month: Number(form.fiscal_year_end_month) });
      toast.success("Réglages enregistrés");
      onSaved(r.data);
      setOpen(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    } finally { setSaving(false); }
  };

  return (
    <div className="bg-white border rounded-xl p-4" data-testid="cabinet-taxes-settings">
      <div className="flex items-center justify-between gap-2">
        <div className="text-sm">
          <span className="text-gray-500">Déclaration</span>{" "}
          <strong data-testid="cabinet-taxes-frequency">{FREQ_LABEL[settings.filing_frequency]}</strong>
          <span className="text-gray-400"> · exercice terminant en </span>
          <strong>{MONTHS[(settings.fiscal_year_end_month || 12) - 1]}</strong>
        </div>
        <button onClick={() => { setForm(settings); setOpen(!open); }}
          className="inline-flex items-center gap-1 text-xs font-semibold text-indigo-700 hover:text-indigo-900"
          data-testid="cabinet-taxes-settings-toggle">
          {open ? <X className="w-3.5 h-3.5" /> : <Settings2 className="w-3.5 h-3.5" />} {open ? "Fermer" : "Modifier"}
        </button>
      </div>
      {open && (
        <div className="mt-3 grid grid-cols-1 sm:grid-cols-3 gap-3 items-end border-t pt-3">
          <label className="text-xs text-gray-500">Fréquence de déclaration
            <select value={form.filing_frequency} onChange={(e) => setForm({ ...form, filing_frequency: e.target.value })}
              className={`${inputCls} mt-1`} data-testid="cabinet-taxes-frequency-select">
              {Object.entries(FREQ_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </label>
          <label className="text-xs text-gray-500">Fin d'exercice (mois)
            <select value={form.fiscal_year_end_month || 12} onChange={(e) => setForm({ ...form, fiscal_year_end_month: Number(e.target.value) })}
              className={`${inputCls} mt-1`} data-testid="cabinet-taxes-fye-select">
              {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
            </select>
          </label>
          <button onClick={save} disabled={saving}
            className="inline-flex items-center justify-center gap-1.5 bg-indigo-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-indigo-700 disabled:opacity-50"
            data-testid="cabinet-taxes-settings-save">
            <Save className="w-4 h-4" /> Enregistrer
          </button>
          <p className="sm:col-span-3 text-[11px] text-gray-400">
            Mensuelle / trimestrielle : échéance un mois après la fin de la période. Annuelle : trois mois après la fin de l'exercice.
            Changer la fréquence recalcule les périodes ; les statuts déjà saisis restent liés à leur ancienne clé de période.
          </p>
        </div>
      )}
    </div>
  );
}
